import moment, { Moment } from 'moment'
import { API_DATE_FORMAT } from 'constants/date'

export const stringifyMomentDate = (date: Moment): string => date.format(API_DATE_FORMAT)

export const parseStringDate = (apiDateString: string): moment.Moment => moment(apiDateString, API_DATE_FORMAT)
